// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2A4Se","cell":"ColumnAccessor_cell__1m5VY","firstCellAccent":"ColumnAccessor_firstCellAccent__3k5Lx"};